import React from 'react';

// Helper to format decimal hours to "Xh Ym" display
const formatHours = (hours) => {
  if (!hours || hours === 0) return '0h';
  const totalMinutes = Math.round(hours * 60);
  const hrs = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  if (hrs === 0) return `${mins}m`;
  if (mins === 0) return `${hrs}h`;
  return `${hrs}h ${mins}m`;
};

export default function TimesheetFooter({ timesheet }) {
  return (
    <div className="px-6 pb-4 pt-2">
      {/* Hours Breakdown */}
      <div className="mb-4 p-3 bg-slate-50 rounded">
        <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-2">Hours Breakdown</p>
        <div className="grid grid-cols-4 gap-4 text-sm">
          <div>
            <p className="text-slate-500 text-[10px]">Travel To Job</p>
            <p className="font-medium text-slate-700">{formatHours(timesheet.travel_to_hours)}</p>
          </div>
          <div>
            <p className="text-slate-500 text-[10px]">Time On Job</p>
            <p className="font-medium text-slate-700">{formatHours(timesheet.on_job_hours)}</p>
          </div>
          <div>
            <p className="text-slate-500 text-[10px]">Travel From Job</p>
            <p className="font-medium text-slate-700">{formatHours(timesheet.travel_from_hours)}</p>
          </div>
          <div>
            <p className="text-slate-500 text-[10px]">Total Hours</p>
            <p className="font-bold text-amber-600">{formatHours(timesheet.total_hours)}</p>
          </div>
        </div>
      </div>
      
      {/* Signature Section */}
      <div className="border-t border-slate-200 pt-4">
        <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-3">Authorization</p>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="border-b border-slate-400 h-6 mb-1" />
            <p className="text-[10px] text-slate-500">Employee Signature & Date</p>
          </div>
          <div>
            <div className="border-b border-slate-400 h-6 mb-1" />
            <p className="text-[10px] text-slate-500">Supervisor Signature & Date</p>
          </div>
        </div>
      </div>
      
      {/* Footer bar */}
      <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between text-[10px] text-slate-400">
        <span>Center Line Locating, LLC · Charlotte, NC · (704) 315-5820</span>
        <span>Timesheet #{timesheet.timesheet_number || timesheet.id}</span>
      </div>
    </div>
  );
}
